import { motion } from "framer-motion";
import { MessageCircle, Phone } from "lucide-react";
import { WHATSAPP_URL, SITE } from "@/constants/site";

export default function CTASection() {
  return (
    <section
      data-testid="cta-section"
      className="relative py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-red-700 via-red-600 to-red-800" />
      <div className="absolute inset-0 bg-noise opacity-[0.06]" />
      <div className="absolute inset-0 diagonal-stripes opacity-30" />
      {/* Dark vignette */}
      <div className="absolute inset-0 bg-black/30" />
      <div className="absolute top-0 left-0 w-full h-1 bg-black" />
      <div className="absolute bottom-0 left-0 w-full h-1 bg-black" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center lg:text-left max-w-2xl"
          >
            <p className="text-xs uppercase tracking-[0.35em] text-white/80 font-bold mb-4">
              Agende sua avaliação
            </p>
            <h2 className="font-display text-3xl md:text-5xl lg:text-6xl font-black uppercase leading-[1] tracking-tighter text-white">
              Seu carro merece<br />
              cuidado <span className="italic font-light">profissional.</span>
            </h2>
            <p className="mt-5 text-white/85 text-base md:text-lg font-body leading-relaxed">
              Fale agora com a Full Force Car Premium e agende uma avaliação para o seu veículo. Atendimento direto pelo WhatsApp.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="flex flex-col gap-4 w-full lg:w-auto"
          >
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-whatsapp-btn"
              className="inline-flex items-center justify-center gap-3 bg-black hover:bg-zinc-900 text-white font-bold py-5 px-10 text-sm uppercase tracking-[0.2em] transition-all duration-300 border-2 border-black shadow-[0_10px_30px_rgba(0,0,0,0.4)] hover:shadow-[0_15px_40px_rgba(0,0,0,0.6)] hover:scale-[1.02]"
            >
              <MessageCircle size={20} strokeWidth={2} />
              Chamar no WhatsApp
            </a>
            <a
              href={`tel:+${SITE.phoneRaw}`}
              data-testid="cta-phone-btn"
              className="inline-flex items-center justify-center gap-3 bg-transparent text-white font-semibold py-3 px-6 text-xs uppercase tracking-[0.2em] border border-white/30 hover:bg-white/10 transition-all duration-300"
            >
              <Phone size={16} strokeWidth={2} /> {SITE.phone}
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
